import { localStore } from 'tradera/utils/storage';
import { STORAGE_KEYS, STORAGE_VALUES } from 'tradera/constants/storage';
import GdprSettings from 'tradera/utils/gdpr-settings';

export const showSaveSearchHint = () =>
    localStore &&
    localStore.getItem(STORAGE_KEYS.SAVE_SEARCH_HINT) !==
        STORAGE_VALUES.SAVE_SEARCH_HINT_CLICKED &&
    GdprSettings.isFunctionalEnabled();

export const hideSaveSearchHint = () =>
    localStore &&
    localStore.setItem(
        STORAGE_KEYS.SAVE_SEARCH_HINT,
        STORAGE_VALUES.SAVE_SEARCH_HINT_CLICKED
    );
